import { Component, Input } from '@angular/core';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DnsInformationModel } from 'services/domain.service';

@Component({
	selector: 'domain-dns-details',
	templateUrl: './domain-dns-details.component.html',
	imports: [Layout, TranslatePipe]
})
export class DomainDnsDetailsComponent {
	@Input() dnsResult?: DnsInformationModel;
}
